import { __assign, __spreadArray, __read } from 'tslib';
import { intervalToDuration, formatDuration } from 'date-fns';

var formatCurrency = function (number, isFraction) {
    if (isFraction === void 0) { isFraction = false; }
    var config = {
        style: 'currency',
        currency: 'RUB',
        minimumFractionDigits: 0,
        maximumFractionDigits: isFraction ? 2 : 0,
    };
    return new Intl.NumberFormat('ru-RU', config).format(number);
};
var formatNumber = function (number, isFraction) {
    if (isFraction === void 0) { isFraction = false; }
    var config = {
        minimumFractionDigits: 0,
        maximumFractionDigits: isFraction ? 2 : 0,
    };
    return new Intl.NumberFormat('ru-RU', config).format(number);
};
var periodToNumber = function (period, value, _a) {
    if (value === void 0) { value = 'months'; }
    var _b = [30, 365] , _c = __read(_b, 2), daysInMonth = _c[0], daysInYear = _c[1];
    var years = period.match(/\d+Y/gm) ? parseInt((period.match(/\d+Y/gm) || [])[0] || '', 10) : 0;
    var months = period.match(/\d+M/gm) ? parseInt((period.match(/\d+M/gm) || [])[0] || '', 10) : 0;
    var days = period.match(/\d+D/gm) ? parseInt((period.match(/\d+D/gm) || [])[0] || '', 10) : 0;
    switch (value) {
        case 'days':
            return years * daysInYear + months * daysInMonth + days;
        case 'years':
            return years + Math.floor(months / 12) + Math.floor(days / daysInYear);
        default:
            return months + years * 12 + (days > 0 ? 1 : 0);
    }
};
var pluralize = function (n, one, few, many) {
    var nP100 = n % 100;
    var nP10 = n % 10;
    if (nP10 === 1 && nP100 !== 11) {
        return one;
    }
    if (nP10 >= 2 && nP10 <= 4 && (nP100 < 10 || nP100 >= 20)) {
        return few;
    }
    return many;
};
var formatPercent = function (number, options) {
    var _a = __assign({ fractionDigits: 2, compact: false }, options), fractionDigits = _a.fractionDigits, compact = _a.compact;
    var result = new Intl.NumberFormat('ru-RU', {
        style: 'percent',
        maximumFractionDigits: fractionDigits,
    })
        .format(number / 100)
        .replace('.', ',');
    if (compact) {
        return result.replace(/\s/, '');
    }
    return result;
};
var pluralizeDays = function (days, isMany) {
    if (isMany === void 0) { isMany = false; }
    // @ts-ignore
    return pluralize.apply(void 0, __spreadArray([days], __read(['день', 'дня', 'дней', 'дней'].slice(isMany ? 1 : 0)), false));
};
var pluralizeMonths = function (months, isMany) {
    if (isMany === void 0) { isMany = false; }
    // @ts-ignore
    return pluralize.apply(void 0, __spreadArray([months], __read(['месяц', 'месяца', 'месяцев', 'месяцев'].slice(isMany ? 1 : 0)), false));
};
var pluralizeYears = function (years, isMany) {
    if (isMany === void 0) { isMany = false; }
    // @ts-ignore
    return pluralize.apply(void 0, __spreadArray([years], __read(['год', 'года', 'лет', 'лет'].slice(isMany ? 1 : 0)), false));
};
var pluralizePeriod = function (period, isGenitive) {
    if (isGenitive === void 0) { isGenitive = false; }
    var years = Math.trunc(period / 12);
    var months = period % 12;
    var yearsPart = years ? "".concat(years, " ").concat(pluralizeYears(years, isGenitive)) : '';
    var monthsPart = months ? "".concat(months, " ").concat(pluralizeMonths(months, isGenitive)) : '';
    return [yearsPart, monthsPart].filter(function (s) { return s; }).join(' ');
};
var formatSecondsToTimer = function (seconds) {
    var duration = intervalToDuration({ start: 0, end: seconds * 1000 });
    return formatDuration(duration, {
        format: ['minutes', 'seconds'],
        zero: true,
        delimiter: ':',
        locale: {
            formatDistance: function (_token, count) { return String(count).padStart(2, '0'); },
        },
    });
};

export { formatCurrency, formatNumber, formatPercent, formatSecondsToTimer, periodToNumber, pluralize, pluralizeDays, pluralizeMonths, pluralizePeriod, pluralizeYears };
//# sourceMappingURL=fomatters.js.map
